// Copyright (c) 2017 Deere & Company

import {getDateFormat} from '../../shared/services/get-date-format';
import {getStore} from '../../store-factory';
import moment from 'moment';

export const buildDate = (timestamp, dateFormatKey) => {

    if (!timestamp) {

        return '';

    }

    const userDateSetting = dateFormatKey ?
        getDateFormat(dateFormatKey) :
        getDateFormat(getStore().getState().user.details.settings.general.dateFormat.key);

    return moment.utc(timestamp).format(userDateSetting);

};

export const getCorrectDateValue = date =>
    date ?
        date.startOf('day').valueOf() :
        null;

export const transformDateValue = date =>
    date ?
        moment.utc(date) :
        null;

export const isValidDate = (date, dateFormatKey) => {

    const dateFormat = dateFormatKey ?
        getDateFormat(dateFormatKey) :
        getDateFormat(getStore().getState().user.details.settings.general.dateFormat.key);

    return moment(date, dateFormat, true).isValid();

};



// WEBPACK FOOTER //
// ./src/shared/services/build-date.js